<template>


<div>
  <!----头部板块开始---->
  <div v-show="cpu_showTop">
      <search></search>
  </div>
  <!----头部板块结束---->
  <router-view></router-view>
</div>

</template>
<script>
// import SwiperBox from "@/components/swiperBox.vue"; // 展示卡片 3
// import ColumnTitle from "@/components/columnTitle.vue"; // 栏目标题 接收string 留有 右边 slot
// import ColumnBox from "../../components/columnBox"; // 申报项目，智能推荐卡片
// import PublicForm from "@/components/publicForm"; // 公开公示表单
// import PlatformStatistics from './platformStatistics.vue';  // 统计
import Search from "./search.vue";
// import homeContent from "./homeContent";
// import PolicyProgram from "@/views/findList/PolicyProgram";
import { mapGetters } from "vuex";
// import DeclareCell from "@/components/declareCell"; // 申报项目，智能推荐卡片
import { Loading } from "element-ui";
// import Qysq from '../qiyesuqiu/qysq.vue';
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "home",
  components: {
    //vueSeamlessScroll,
    // SwiperBox,
    // SwiperItemList,
    // ColumnTitle,
    // ColumnBox,
    // PublicForm,
    // PlatformStatistics,
    // PolicyProgram,
    // DeclareCell,
    // homeContent,
    // Qysq,
    Search
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      hNavAction: "hNavAction",
    }),
    cpu_noticeList() {
      return this.noticeList.slice(0, 4);
    },
    classOption() {
      return {
        step: 0.1, //数值越大速度滚动越快
        limitMoveNum: 5, //开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
    /**
     * @description: 显示顶部轮播区域
     * @return {Boolean}
     */
    cpu_showTop() {
      switch (this.$route.path) {
        case '/policyService':
        case '/policy-advisory':
          return false;
        default:
          break;
      }
      if (this.titleType === 1) return true;
      return false;
    },
  },
  data() {
    return {
      imgSrc: [
        // { url: require("../../assets/images/banner_swipe1.png") },
        { url: require("../../assets/images/Background3.png") },
        { url: require("../../assets/images/Background2.png") },
        { url: require("../../assets/images/Background3.png") },
        { url: require("../../assets/images/Background2.png") },
        // { url: require("../../assets/images/banner_swipe2.png") },
      ],
      collectList: [],
      dialogVisible: false,
      search: "",
      // 通知公告列表
      noticeList: [],
      // 联系
      toolbarRightList: [
        {
          name: "政策匹配", // name
          path: "http://fsfczj.foshan.gov.cn/#/intelligence", // 转跳信息
        },
        {
          name: "国家政务服务中心", // name
          path: "http://fsfczj.foshan.gov.cn/#/intelligence", // 转跳信息
        },
        {
          name: "广东省中小企业", // name
          path: "http://fsfczj.foshan.gov.cn/#/intelligence", // 转跳信息
        },
      ],
      // 展示 卡片
      swiperList: [
        {
          title: "小微企业和个体工商户服务专栏",
          subtitle: "小微企业和个体工商户服务专栏",
          bc: require("@/assets/images/tips_1.png"),
          id: "1",
        },
        {
          title: "粤港澳大湾区服务专栏",
          subtitle: "开创融合新格局",
          bc: require("@/assets/images/tips_2.png"),
          id: "2",
        },
        {
          title: "其他惠企服务专区",
          subtitle: "企业融资与金融普惠",
          bc: require("@/assets/images/tips_3.png"),
          id: "3",
        },
      ],
      swiperItemList: [
        {
          title: "小微企业和个体工商户服务专栏",
          subtitle: "小微企业和个体工商户服务专栏",
          bc: require("@/assets/images/tips_1.png"),
          id: "1",
        },
        {
          title: "粤港澳大湾区服务专栏",
          subtitle: "开创融合新格局",
          bc: require("@/assets/images/tips_2.png"),
          id: "2",
        },
        {
          title: "其他惠企服务专区",
          subtitle: "企业融资与金融普惠",
          bc: require("@/assets/images/tips_3.png"),
          id: "3",
        },
        {
          title: "其他惠企服务专区",
          subtitle: "企业融资与金融普惠",
          bc: require("@/assets/images/tips_3.png"),
          id: "3",
        },
      ],
      // 热门申报项目卡片
      declaList: [],
      // 智能推荐
      recomList: [],
      // 公告列表数据
      publicList: [],
      titleType: 1,
    };
  },
  created() {
    let titleType = sessionStorage.getItem("titleType");
    if (titleType) {
      this.titleType = Number(titleType);
    }
  },
  mounted() {
    // this.getEnterpriseList();	// 用于判断是否需要提示补充基本信息
    // this.getCollectList();

    // UI改版后，暂不需要热门申报了
    // this.getHotDecla();

    // this.getPublicList();

    this.getRecomList();
    this.getPublicList();
  },
  methods: {
    /**
     * @description 前往二维码登录页
     */
    toQrLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    /**
     * 获取通知公告
     */
    getPublicList() {
      let loadingnoticeRef = Loading.service({
        target: this.$refs.noticeRef,
      });
      // type 1项目政策 2通知公告 3公开公示
      let params = {
        pageNum: 1,
        pageSize: 20,
        type: 2,
      };
      this.$httpApi
        .get(`/dev-api/document/list`, params)
        .then((res) => {
          if (res.code === 200) {
            loadingnoticeRef.close();
            // this.noticeList = res.rows;
            let target = JSON.parse(JSON.stringify(res.rows));
            target.sort(function (a, b) {
              return a.policypubdate < b.policypubdate ? 1 : -1;
            });
            this.noticeList = target;
          }
        })
        .catch((err) => {
          loadingnoticeRef.close();
        });
    },
    /**
     * 转跳到通知公告列表
     */
    noticeMore() {
      let { href } = this.$router.resolve({
        path: "/noticeNotice",
      });
      window.open(href, "_blank");
    },
    /**
     * 转跳到通知公告详细
     */
    noticeTodo(val) {
      let that = this;
      // console.log("点击,转跳", val);
      // this.$router.push({
      //   path: "/notice/detail/" + val.id+"?type="+that.itemType
      // });
/*      let { href } = that.$router.resolve({
        path: "/notice/detail/" + val.id + "?type=" + that.itemType,
      });
      window.open(href, "_blank");*/
      this.$router.push({
        path: "/notice/detail/" + val.id + "?type=" + that.itemType,
      })
    },
    /**
     * 热门申报
     */
    getHotDecla() {
      let date = new Date();
      let year = date.getFullYear();
      let pageNum = 0;
      let pageSize = 100;
      let params = { pageNum: pageNum, pageSize: pageSize, year: year };
      this.$httpApi
        .get("/dev-api/basicinfo/baseitem/hot-list", params)
        .then((res) => {
          console.log("热门申报:", res);
          if (res.code == 200) {
            // let resList = res.data
            // for ( let i = 0 ; i < resList.length ; i++ ) {
            // 	let objitem = resList[i]
            // 	for ( let el in objitem ) {
            // 		el = this.lowerJSONKey(el)
            // 		console.log("el", el)
            // 	}
            // }
            // console.log(">>>", res.rows)
            this.declaList = res.data;
          }
        })
        .catch((err) => {});
    },
    // 小写转换
    lowerJSONKey(jsonObj) {
      for (var key in jsonObj) {
        jsonObj['"' + key.toLowerCase() + '"'] = jsonObj[key];
        delete jsonObj[key];
      }
      return jsonObj;
    },

    /**
     * 公告详细信息
     * @param {string} id 传项目id
     */
    getNoticeInfo(id) {
      if (id) {
        this.$httpApi.get(`/dev-api/document/${id}`, {}).then((res) => {
          // console.log("公告详细信息:", res);
        });
      }
    },

    /**
     * 获取搜索信息
     */
    getSearchInfo(...el) {
      console.log("获取的搜索条件", ...el);
    },

    /**
     * 热门申报转跳
     */
    swiTo(e) {
      console.log("卡片转跳信息", e);
      sessionStorage.setItem("specialColumn", JSON.stringify(e));
      let id = e.id;
      if (id == 3) {
        let href =
          "http://zxr.gdjr.gd.gov.cn/portal/static/cofinance/index.html";
        window.open(href, "_blank");
      } else if (id == 2) {
        this.$router.push({
          path: `/specialGangaoyueColumn/${id}`,
        });
      } else {
        this.$router.push({
          path: `/specialColumn/${id}`,
        });
      }
    },

    /**
     * 热门项目收藏点击
     */
    clickIsFollow(item) {
      //判断是否登录
      if (this.$store.getters.getUserInfo) {
        //登录
      } else {
        //未登录
        this.dialogVisible = true;
      }
    },
    /**
     * 登录提示框点击确定登录，跳转登录页面
     */
    gotoLogin() {
      console.log("跳转登录页面");
      this.$router.push({
        path: "/login",
      });
    },

    /**
     * 申报 + 推荐 卡片点击事件
     * @param {object} item 卡片信息
     * @return 转跳到申报详细
     */
    clickCell(item) {
      this.$store.commit("updateCurrentGuideId", item.ID || item.id);
      // if (["1", "2"].indexOf(item.ITEMTYPE || item.itemtype) > -1) {
      //   this.$router.push({
      //     path: "/guideShenpi",
      //     query: {
      //       name: item.ITEM_BASE_NAME || item.itemBaseName,
      //     },
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/guideSuqiu",
      //   });
      // }
      this.$router.push({
        path: "/guideSuqiu",
        query: {
          name: item.ITEM_BASE_NAME,
          itemType: item.itemtype || "",
          isAdded: item.isAdded || "",
        },
      });
      // 修改 header nav 状态
      this.$store.commit("updateHNavAction", "/projectList");
    },
    /**
     * 申报栏  获取更多 转跳到申报栏目
     */
    getMore() {
      // 修改 header nav 状态
      this.$store.commit("updateHNavAction", "/findList");
      this.$router.push({
        path: "/findList",
      });
    },

    /**
     * 智能推荐 刷新
     * @return {array} 随机数组供显示
     */
    getUpdata() {
      /* 重新获取信息 */
      this.getRecomList();
      /* 筛选信息条数 */
      // aryanimals.slice(0, 3)     // 浅拷贝
    },
    getRecomList() {
      let userInfo = this.$store.getters.getUserInfo;
      if (userInfo) {
        // console.log("用户统一社会信用代码：",userInfo.shxydm)
        let params = {
          shxydm: userInfo.tyshxydm,
        };
        // console.log("智能推荐参数：", params);
        this.$httpApi
          .get("/dev-api/basicinfo/baseitem/getEnterPermitItem", params)
          .then((res) => {
            console.log("智能推荐：", res);
            this.recomList = res.data.items.slice(0, 3);
          })
          .catch((err) => {
            console.log("获取智能推荐失败：", err);
          });
      } else {
        this.recomList = [];
      }
    },
    //查询所有的收藏列表,之后需要比对事项的收藏状态
    getCollectList() {
      if (this.$store.getters.getUserInfo) {
        let identify = this.$store.getters.getUserInfo.shxydm;
        let param = {
          identify: identify,
          type: "1,2,3,4,5,6",
          pageNum: 1,
          pageSize: 100,
        };
        let url = "/dev-api/collection/list";

        this.$httpApi
          .get(url, param)
          .then((res) => {
            console.log("收藏的列表" + res);
            if (res.code == 200) {
              this.collectList = res.rows;
            }
          })
          .catch((err) => {});
      }
    },
    //比对收藏列表,判断是否收藏
    isItemCollect(item) {
      let list = this.collectList;

      for (let i = 0; i < list.length; i++) {
        let collectItem = list[i];
        if (item.ID == collectItem.collectionId) {
          console.log(item.name + ":已收藏");
          return collectItem;
        }
      }
      return null;
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler: function (newVal, oldVal) {
        // console.log('userInfo:', newVal)
      },
    },
    $route: {
      handler: function (val, oldVal) {
        // console.log(val);
        if(val.params.titleType){
          this.titleType = val.params.titleType;
        }
       else{
          if(val.fullPath=='/policyLibrary'){
          this.titleType = 1
        }
        else{
          this.titleType = 0
        }
       }
      },
    },
  },
};
</script>

